import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAlert } from "../../Provider/Alert/AlertContext";
import { putData, getData } from "../../Services/apiService";

export function useLicenseForm({
    idClient,
    license = null,
    onClose = () => {},
    reload = () => {},
}) {
    const { t } = useTranslation(); // Translation hook
    const { addAlert } = useAlert(); // Alert hook
    const [formLicense, setFormLicense] = useState({});
    const [contracts, setContracts] = useState([]);

    // Effect to set form data when editing
    useEffect(() => {
        if (license && license.id) {
            const listContract = async () => {
                await getContract(license.client.id);
            };
            listContract();
            setFormLicense(license);
        }
    }, [license]);

    useEffect(() => {
        console.log("formLicense", formLicense);
    }, [formLicense]);

    const getContract = async (idClient) => {
        try {
            const uri = `/client/${idClient}/contract?page=1&limit=1000`;
            const response = await getData(uri);
            if (response.status === 200) {
                setContracts(response.body.data);
            } else {
                setContracts([]);
            }
        } catch (error) {
            console.error(error);
            setContracts([]);
        }
    };

    // Handle the form submit
    const handleFormSubmit = async () => {
        // Call the API to update the license
        console.log("Submitting formLicense:", formLicense);

        try {
            const saveLicense = await putData(
                "/license",
                license.id,
                {
                    hostname: formLicense.hostname,
                    status: formLicense.status,
                    expires_at: formLicense.expires_at,
                    id_contract: formLicense.contract
                        ? parseInt(formLicense.contract.id, 10)
                        : null,
                }
            );

            console.log("saveLicense response:", saveLicense);

            if (saveLicense.status === 200) {
                addAlert(
                    "success",
                    t("licenses.form.alert.success.title"),
                    t("licenses.form.alert.success.message")
                );
                reload();
                setFormLicense({});
                onClose();
            } else {
                addAlert(
                    "danger",
                    t("licenses.form.alert.error.title"),
                    t("licenses.form.alert.error.message")
                );
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleFormCancel = () => {
        setFormLicense({});
        onClose();
    };

    return {
        formLicense,
        setFormLicense,
        handleFormSubmit,
        handleFormCancel,
        contracts,
    };
}
